import { Link } from "react-router-dom";
import { Calendar, Clock } from "lucide-react";
import type { BlogPost } from "@/content/blog/posts";

const formatDate = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

interface Props {
  post: BlogPost;
  eager?: boolean;
}

export const BlogCard = ({ post, eager = false }: Props) => (
  <article className="group h-full">
    <Link
      to={`/blog/${post.slug}`}
      className="flex h-full flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition hover:shadow-md hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#de0046] focus-visible:ring-offset-2 focus-visible:ring-offset-[#fbf9f4]"
    >
      <div className="aspect-video overflow-hidden bg-slate-100">
        <img
          src={post.coverImage}
          alt={post.coverAlt}
          width={1600}
          height={896}
          loading={eager ? "eager" : "lazy"}
          className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.03]"
        />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[11px] uppercase tracking-[0.18em] text-[#de0046] font-bold mb-2">
          {post.category}
        </p>
        <h3 className="font-serif text-xl leading-snug text-slate-900 group-hover:text-[#de0046] transition-colors mb-2">
          {post.title}
        </h3>
        <p className="text-sm text-slate-600 leading-relaxed line-clamp-2 mb-4">
          {post.description}
        </p>
        <div className="mt-auto flex items-center gap-4 text-xs text-slate-500">
          <time dateTime={post.date} className="flex items-center gap-1.5">
            <Calendar size={12} aria-hidden="true" />
            {formatDate(post.date)}
          </time>
          <span className="flex items-center gap-1.5">
            <Clock size={12} aria-hidden="true" />
            {post.readingMinutes} min
          </span>
        </div>
      </div>
    </Link>
  </article>
);

export default BlogCard;
